/* assets/mos-stock-gauge.js — the stock-on-hand gauge, on product cards.
 *
 * The product page already has a full stock panel (pdp-stock.js, in Shopify Files). This puts
 * a miniature of it on cards — the header search dropdown, collection and search grids, Keep
 * Browsing — beside the RRP.
 *
 * The bands and the state order are COPIED FROM pdp-stock.js and must stay copied:
 *
 *     qty <= 0    Restocking   #9F0C0C
 *     qty <= 10   Last Few     #CE5F13
 *     qty <= 50   Low Stock    #FAB219
 *     qty >  50   In Stock     #319F0C
 *     states      QLD NSW VIC WA SA
 *
 * A card that disagreed with the panel one click later would be worse than no card gauge at
 * all, so the levels are not computed here. assets/../mos-card-stock.json is generated with
 * those exact bands already applied — including the pack-size divisor from itf-packs.json —
 * and holds one 5-character string per handle. 17,550 handles, 253KB over the wire compressed.
 *
 * A handle MISSING from that file means nobody feeds us stock for that product. That is a
 * different fact from "all five states are zero", and it renders as nothing at all rather than
 * as out of stock. Getting that wrong would tell a customer a product is unavailable when the
 * truth is only that we do not know.
 *
 * The file is fetched lazily — after first paint, and only once a card is actually on the page.
 */
(function () {
  'use strict';

  if (window.__mosStockGauge) return;

  var CFG = window.mosStockGaugeConfig || {};
  var API = (window.__mosStockGauge = {
    version: 1,
    state: 'idle',
    handles: 0,
    marked: 0,
    matched: 0,
    unknown: 0,
    lastError: null,
    source: null
  });

  if (CFG.enabled === false) { API.state = 'off'; return; }

  var LEVELS = [
    { key: 'pre', color: '#9F0C0C', label: 'Restocking' },
    { key: 'few', color: '#CE5F13', label: 'Last Few' },
    { key: 'low', color: '#FAB219', label: 'Low Stock' },
    { key: 'in',  color: '#319F0C', label: 'In Stock' }
  ];
  var STATES = ['QLD', 'NSW', 'VIC', 'WA', 'SA'];

  var DATA = null;

  /* ------------------------------------------------------------------ data */

  function load() {
    if (API.state !== 'idle') return;
    if (!CFG.url) { API.state = 'no-url'; return; }
    API.state = 'loading';
    fetch(CFG.url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.s) { API.state = 'empty'; return; }
        DATA = d.s;
        if (Array.isArray(d.states) && d.states.length === 5) STATES = d.states;
        API.handles = Object.keys(DATA).length;
        API.source = d.source || null;
        API.state = 'ready';
        sweep();
      })
      .catch(function (e) { API.state = 'error'; API.lastError = String(e); });
  }

  /* --------------------------------------------------------------- helpers */

  function handleFrom(root) {
    var a = root.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var m = /\/products\/([^/?#]+)/.exec(href);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  // Walk up looking for the element that holds both the price and the product link. Capped so
  // a card with no link of its own cannot climb out and adopt a neighbour's handle.
  function cardFor(priceEl) {
    var e = priceEl;
    for (var i = 0; i < 6 && e; i++) {
      if (e.querySelector && e.querySelector('a[href*="/products/"]')) return e;
      e = e.parentElement;
    }
    return null;
  }

  function build(levels) {
    var wrap = document.createElement('span');
    wrap.className = 'mos-sg';
    wrap.setAttribute('data-mos-sg', '1');

    var best = -1, tip = [];
    for (var i = 0; i < 5; i++) {
      var n = parseInt(levels.charAt(i), 10);
      if (!isFinite(n) || n < 0 || n > 3) n = 0;
      if (n > best) best = n;
      var bar = document.createElement('span');
      bar.className = 'mos-sg__bar mos-sg__bar--' + LEVELS[n].key;
      bar.style.background = LEVELS[n].color;
      wrap.appendChild(bar);
      tip.push(STATES[i] + ' ' + LEVELS[n].label);
    }
    // A single word next to the bars, because five coloured ticks on their own are a puzzle.
    // It reports the best state, which is the honest summary of "can I get this".
    var txt = document.createElement('span');
    txt.className = 'mos-sg__text';
    txt.style.color = LEVELS[best < 0 ? 0 : best].color;
    txt.textContent = LEVELS[best < 0 ? 0 : best].label;
    wrap.appendChild(txt);

    wrap.setAttribute('title', tip.join('  ·  ') + (API.source && API.source.built ? '\n\nStock as at ' + API.source.built : ''));
    wrap.setAttribute('aria-label', 'Stock: ' + tip.join(', '));
    return wrap;
  }

  /* -------------------------------------------------------------- placement */

  // Two card templates on this store, with nothing in common.
  //   the theme's own cards (search dropdown, Keep Browsing, recommendations) use .price
  //   the vendor's Preact cards (collection and search grids) use build-hashed class names,
  //     read out of search-app.css's own class map rather than guessed:
  //       priceRow snSK2B2rTshsCWMccngR / price cDR1VACLC4cbonUqBKmG / rrp kROvqDW_6WsjgBJ1JAHD
  //     If Moustache Republic rebuild, those hashes change and this quietly stops matching the
  //     vendor cards. The theme cards keep working, and nothing breaks.
  var PRICE_SELECTORS = (CFG.priceSelectors || '.price, .snSK2B2rTshsCWMccngR').split(',');

  function slotIn(priceEl, gauge) {
    // Theme card: inside the sale row, after the RRP, so it reads price - RRP - gauge.
    var sale = priceEl.querySelector('.price__sale');
    if (sale) {
      var dd = document.createElement('dd');
      dd.className = 'mos-sg__slot';
      dd.appendChild(gauge);
      sale.appendChild(dd);
      return true;
    }
    var dl = priceEl.querySelector('dl');
    if (dl) {
      var dd2 = document.createElement('dd');
      dd2.className = 'mos-sg__slot';
      dd2.appendChild(gauge);
      dl.appendChild(dd2);
      return true;
    }
    // Vendor card, or anything else: straight onto the end of the price row.
    priceEl.appendChild(gauge);
    return true;
  }

  function sweep() {
    if (API.state !== 'ready' || !DATA) return;
    var els = document.querySelectorAll(PRICE_SELECTORS.join(','));
    for (var i = 0; i < els.length; i++) {
      var priceEl = els[i];
      if (priceEl.getAttribute('data-mos-sg-done')) continue;
      var card = cardFor(priceEl);
      if (!card) continue;
      priceEl.setAttribute('data-mos-sg-done', '1');
      API.marked++;
      var h = handleFrom(card);
      if (!h) continue;
      var levels = DATA[h];
      if (typeof levels !== 'string' || levels.length < 5) {
        // Not in the feed: nobody supplies us stock for it. Render nothing — see the header.
        API.unknown++;
        continue;
      }
      try {
        slotIn(priceEl, build(levels));
        API.matched++;
      } catch (e) { API.lastError = String(e); }
    }
  }

  /* ------------------------------------------------------------------ boot */

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; try { sweep(); } catch (e) {} }, 80);
  }

  function anyCards() {
    return !!document.querySelector(PRICE_SELECTORS.join(','));
  }

  function start() {
    // Lazy on two counts: after first paint, and only when there is actually a card to decorate.
    // 253KB is not worth fetching on a page that has no prices on it.
    var began = false;
    function maybeLoad() {
      if (began || !anyCards()) return;
      began = true;
      load();
    }
    var obs = new MutationObserver(function () { maybeLoad(); schedule(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    var kick = function () { maybeLoad(); schedule(); };
    if (window.requestIdleCallback) window.requestIdleCallback(kick, { timeout: 2000 });
    else setTimeout(kick, 600);
    window.addEventListener('load', kick);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
